import classes from './HeaderTitle.module.scss'

const HeaderTitle = () => {
   return (
      <div className={classes.Header_title}>
         <p>MADE</p>
         <p>FOR YOU</p>
         <p>MADE FOR YOU</p>
      </div>
   )
}

export default HeaderTitle